import { BiChevronRight } from "react-icons/bi";
import { TbPill } from "react-icons/tb";
import { CarePlusMedication } from "../../ChooseTreatmentCarePlus/types";
import { buildImageUrl, dosageRange, intakeFrequency, minDosagePrice } from "../helpers";
import PriceValue from "./PriceValue";

const InjectionIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
  <g clipPath="url(#clip0_5086_94095)">
    <path d="M7.49479 0.828125L9.16145 2.49479M7.07812 2.91146L8.32812 1.66146M7.91145 3.74479L3.61979 8.03646C3.20312 8.45312 2.57812 8.45312 2.20312 8.03646L1.95312 7.78646C1.53645 7.36979 1.53645 6.74479 1.95312 6.36979L6.24479 2.07812M3.74479 4.57812L5.41145 6.24479M2.07812 7.91146L0.828125 9.16146M5.82812 1.66146L8.32812 4.16146" stroke="#99A3B3" strokeLinecap="round" strokeLinejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_5086_94095">
      <rect width="10" height="10" fill="white"/>
    </clipPath>
  </defs>
</svg>
);

export const FrequencyIcon = ({ medication }: { medication: CarePlusMedication }) => {
  const frequency = intakeFrequency(medication, (key, fallback) => fallback);
  const isInjection = /injection/i.test(frequency);

  return isInjection ? <InjectionIcon /> : <TbPill size={10} className="text-[#99a3b2]" />;
};

const ModalOptionRow = ({ medication, onSelect, t }: { medication: CarePlusMedication; onSelect: () => void; t: (key: string, fallback: string) => string }) => {
  const imageUrl = buildImageUrl(medication.image);
  return (
    <button
      id={`wl3_treatment_modal_option_${medication.catalog_id}`}
      type="button"
      onClick={onSelect}
      className="flex w-full cursor-pointer items-start gap-[14px] rounded-[12px] border border-[#b5bdcc] bg-white p-3 text-left drop-shadow-[0px_12px_6px_rgba(0,0,0,0.05)]"
    >
      <div className="flex h-[91px] w-[95px] shrink-0 items-center justify-center overflow-hidden rounded-[6px] bg-[#f5f6f7]">
        {imageUrl && <img src={imageUrl} alt={medication.title} className="h-full w-full object-contain" />}
      </div>
      <div className="flex min-w-0 flex-1 flex-col justify-between self-stretch">
        <p className="text-[18px] font-medium leading-[1.2] text-[#08080a]">{medication.title}</p>
        <div className="flex items-end justify-between">
          <div className="flex min-w-0 flex-col gap-2">
            {/* Dose range, as on the "Weitere Behandlungsoptionen" cards. */}
            {dosageRange(medication) && (
              <p className="text-[10px] leading-[15px] text-[#99a3b2]">{dosageRange(medication)}</p>
            )}
            <div className="flex items-center gap-1">
              <FrequencyIcon medication={medication} />
              <p className="text-[10px] leading-[15px] text-[#808080]">{intakeFrequency(medication, t)}</p>
            </div>
            <p className="text-[12px] font-medium leading-[18px] text-[#616975]">
              <PriceValue value={minDosagePrice(medication)} prefix={`${t("from", "from")} `} suffix={` ${t("per_mo", "/mo")}`} />
            </p>
          </div>
          <div className="flex size-8 shrink-0 items-center justify-center rounded-full bg-[#f5f6f7]">
            <BiChevronRight size={16} className="text-[#08080a]" />
          </div>
        </div>
      </div>
    </button>
  );
};

export default ModalOptionRow;
